// extracted by mini-css-extract-plugin
export default {"danger_btn":"styles_danger_btn__+vwMr","danger_btn_md":"styles_danger_btn_md__D7imK","danger_btn_sm":"styles_danger_btn_sm__sW9aJ","danger_btn_lg":"styles_danger_btn_lg__Z+Qtq"};